import { createUseStyles } from 'react-jss'
import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  select: {
    color: theme.palette.grey[800],
    background: 'white',
    borderRadius: 8,
    ...typography['Lato Body 1'],
  },
}))

export const selectMenu = (theme: Theme) => ({
  zIndex: 9999,
  color: theme.palette.grey[800],
  ...typography['Lato Body 1'],
})
